import React from "react";
import WhyWool from "../components/WhyWool/WhyWool";

const WhyWoolPage = () => {
	return <WhyWool />;
};

export default WhyWoolPage;
